import "./App.css";
import Nav from "./layout/Nav";
import { Routes, Route } from "react-router-dom";
import { Home } from "./pages/home/Home";
import { Director } from "./pages/about/Director";
import { Teacher } from "./pages/about/Teacher";
import { Law } from "./pages/document/Law";
import { Calendar } from "./pages/document/Calendar";
import { Gallery } from "./pages/gallery/Gallery";
import { Contact } from "./pages/contact/Contact";
import PostPage from "./pages/home/PostPage";
import { Philosophys } from "./pages/about/Philosophys";
import { Structure } from "./pages/about/Structure";
import { Footer } from "./layout/Footer";
import { Club } from "./pages/document/Club";
import {Shinagana} from "./pages/document/Shinagana"
import { Docs } from "./pages/document/Docs";
import { Gegma } from "./pages/document/Gegma";
import { Strategiuli } from "./pages/about/Strategiuli";
import { Xarisxi } from "./pages/about/Xarisxi";
import { Moswservice } from "./pages/about/Moswservice";
import { Skolisombuts } from "./pages/about/Skolisombuts";
import { Finansebi } from "./pages/document/Finansebi";
import { Charicxvebi } from "./pages/about/Charicxvebi";
import { Procedura } from "./pages/about/Procedura";
import { Personal } from "./pages/about/Personal";
function App() {
  return (
    <>
      <Nav />

      <div className="full">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/school/philosophy" element={<Philosophys />} />
          <Route path="/school/structure" element={<Structure />} />
          <Route path="/director" element={<Director />} />
          <Route path="/teacher" element={<Teacher />} />
          <Route path="/law" element={<Law />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/post/:id" element={<PostPage />} />
          <Route path="/Club" element={<Club />} />
          <Route path="/action" element={<Shinagana />}/>
          <Route path="/docs" element={<Docs />}/>
          <Route path="/gegma" element={<Gegma />}/>
          <Route path="/stragetiuli" element={<Strategiuli />} />
          <Route path="/xarisxi" element={<Xarisxi />} />
          <Route path="/moswservice" element={<Moswservice />} />
          <Route path="/ombudsmeni" element={<Skolisombuts />} />
          <Route path="/finansebi" element={<Finansebi />} />
          <Route path="/charicxvebi" element={<Charicxvebi />} />
          <Route path="/charicxva" element={<Procedura />} />
          <Route path="/personal" element={<Personal/>} />

          
        </Routes>
      </div>

      <Footer />
    </>
  );
}

export default App;
